import { render, staticRenderFns } from "./TestimonialsPage.vue?vue&type=template&id=3a0795cf&"
import script from "./TestimonialsPage.vue?vue&type=script&lang=js&"
export * from "./TestimonialsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports